import { AwarenessCampaignData, AwarenessCampaignStatus } from '../models/AwarenessCampaign';

/**
 * Checks if a campaign is completed for a specific user or globally
 * @param campaign The campaign data
 * @param userEmail The email of the user to check
 * @returns True if the campaign is completed, false otherwise
 */
export const isCampaignCompleted = (
  campaign: AwarenessCampaignData,
  userEmail?: string | null
): boolean => {
  
  // If the campaign is globally completed
  if (campaign.status === AwarenessCampaignStatus.COMPLETED) {
    return true;
  }
  
  // If we want to check for a specific user and they have a completion status
  if (userEmail && campaign.ambassadorsStatus && campaign.ambassadorsStatus[userEmail]) {
    return campaign.ambassadorsStatus[userEmail] === AwarenessCampaignStatus.COMPLETED;
  }
  
  return false;
}; 